import { render } from "./ShiftCostsShortcut.vue?vue&type=template&id=8498c7f0&scoped=true&ts=true"
import script from "./ShiftCostsShortcut.vue?vue&type=script&lang=ts"
export * from "./ShiftCostsShortcut.vue?vue&type=script&lang=ts"

import "./ShiftCostsShortcut.vue?vue&type=style&index=0&id=8498c7f0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8498c7f0"]])

export default __exports__